export default {
  pathPrefix: 'expansion',
  items: [
    {
      label: 'Overview',
      href: '/expansion/overview',
      icon: 'fa-solid fa-house',
      activePath: 'expansion/overview'
    },
    {
      label: 'Dashboard',
      href: '/expansion/dashboard',
      icon: 'fa-solid fa-map-location-dot',
      activePath: 'expansion/dashboard'
    }
  ]
}
